const getters = {
  getEditedFields(state, getters) {
    return state.editedFields;
  },
};

export default getters;
